import { CustomerProfilesStatus } from 'types/twilio/twilioCustomerProfile';

/**
 * https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/collect-business-info#business_type
 */
export enum TwilioBusinessType {
  CO_OPERATIVE = 'Co-operative',
  CORPORATION = 'Corporation',
  LIMITED_LIABILITY_CORPORATION = 'Limited Liability Corporation',
  NON_PROFIT_CORPORATION = 'Non-profit Corporation',
  PARTNERSHIP = 'Partnership',
}

/**
 * https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/collect-business-info#business_registration_identifier
 */
export enum TwilioBusinessRegistrationIdentifier {
  EIN = 'EIN',
  DUNS = 'DUNS',
  CBN = 'CBN',
  CN = 'CN',
  ACN = 'ACN',
  CIN = 'CIN',
  VAT = 'VAT',
  VATRN = 'VATRN',
  RN = 'RN',
  Other = 'Other',
}

export const ALLOWED_STATUSES_TO_SUBMIT: Readonly<CustomerProfilesStatus[]> = ['draft', "twilio-rejected"];
